import { render, staticRenderFns } from "./InformativeModal.vue?vue&type=template&id=5d3abfac&"
import script from "./InformativeModal.vue?vue&type=script&lang=js&"
export * from "./InformativeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports